import { ScopeOptionsT } from 'business/definitions';
import { getScopeField } from 'components/inputs/TreeTablePicker/helpers';
import { TFunction } from 'i18next';

export const improveLabelForDefaultScopes = (
    scopes: ScopeOptionsT[],
    filter: SentenceFilterWithScopesT,
    t: TFunction,
) =>
    scopes.map((scope) => {
        let { label } = scope;
        if (scope.value.startsWith('scope:default')) {
            const scopeField = getScopeField(scope.value);
            const queryPerimeterLabel = `queryPerimeter.${scopeField}.${filter.field}`;
            const labelTranslation = t(queryPerimeterLabel);
            if (labelTranslation !== queryPerimeterLabel) {
                label = labelTranslation;
            }
        }
        return {
            ...scope,
            label,
        };
    });

/**
 * Filters a tree structure based on the provided scope values.
 *
 * @param tree - The tree structure to filter, represented as an array of nodes.
 * @param scopeValues - An array of string values that determine which nodes are in scope.
 * @param parentInScope - A boolean indicating if the parent node is in scope. Defaults to false.
 * @returns A new tree structure with nodes filtered based on the scope values.
 */
export const filterTreeValues = (
    tree: TreeT[],
    scopeValues: string[],
    parentInScope: boolean = false,
): TreeT[] => {
    return tree
        .map((node) => {
            const inScope = scopeValues.includes(node.value);
            if (inScope) {
                return { ...node, children: node.children };
            }

            const filteredChildren = filterTreeValues(
                node.children,
                scopeValues,
                inScope || parentInScope,
            );

            if (filteredChildren.length > 0) {
                return { ...node, children: filteredChildren };
            }

            return null;
        })
        .filter((node) => node !== null);
};
